import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import parseEvent from './helpers/parseEvent';
import { netEntParseEvent, netEntParseEventWeb } from './helpers/netEntParseEvent';
import store from '../../state/store';
import { addXp } from '../../state/slices/xp/xp';
import { addCoins, setCoin, subtractCoins, setLastWin } from '../../state/actions/extras';
import { tooltipDetails, shouldShowTooltip } from '../../state/actions/tooltip';
import { clearOnboarding, setOnboardingFtueStep, setOnboardingHighlightedPosition } from '../../state/actions/currentOnboarding';
import { setLastTimeRatingSeen } from '../../state/actions/playerInfo';
import jsonParser, { Name as jsonParserName } from './helpers/jsonParser';
import kvpParser, { Name as kvpParserName } from './helpers/KeyValuePairParser';
import { getLevelUpData } from '../../state/query/levelUp';
import QueryParamsProxy from '../../utils/queryParamProxy';
import RouteParamConstants from '../../utils/routeParamConstants';
import Screens from '../../screens/index';
import ShowRateUs from '../../utils/ShowRateUs';
import Logger from '../../lib/analytics/logger';
import appUtils from '../../utils/';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import { TooltipTypes } from '../../utils/tooltipConstants';
import useFeatureFlags from '../../hooks/useFeatureFlags';
import { FLAG_DEFAULT_VALUES } from '../../utils/featureFlags/constants';
import generalUtils from '../../utils';
import { getText, TEXT_KEY } from '../../utils/localization';
import ERROR_CODE from '../../utils/errorCodes';
import { FE_LAYOUT } from '../../utils/featureFlags/constants';
import { LAYOUT, NAVIGATION_BAR_LAYOUT } from '../../constants';
import { getBattlesAndMissions } from '../../state/query/unifiedQuerys/battlesMissions';

/**
 * @class
 * @virtual
 * Base class for interacting with games. Implements common functionality and helpers.
 * This class should not be used directly. Instantiate a subclass according to the game provider.
 */
var GameInterface = /*#__PURE__*/function () {
  /**
   * GameInterface constructor
   * @param {Object} args
   * @param {import("../Constants").BetInfo} args.BetInfo
   * @param {Function} args.ExitFunc
   */
  function GameInterface(args) {
    var _this = this,
      _args$BetInfo,
      _args$BetInfo2;
    _classCallCheck(this, GameInterface);
    this._dispatcher = null;
    this._exitFunc = function () {};
    this.messageHandle = function (message, provider) {
      var event;
      switch (provider) {
        case 'netent':
          if (appUtils.isWebOrMobileWeb()) {
            event = netEntParseEvent(message, _this.parsers);
          } else {
            event = netEntParseEventWeb(message, _this.parsers);
          }
          break;
        default:
          event = parseEvent(message, _this.parsers);
          break;
      }
      if (event) {
        _this.receivedEvent(event);
      }
    };
    /**
     * Generic JSON Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    this.jsonParserEvent = function (event) {
      console.warn("Unhandled JSONParserEvent: ".concat(JSON.stringify(event)));
    };
    /**
     * Generic KVP Event Handler
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    this.kvpParserEvent = function (event) {
      console.warn("Unhandled kvpParserEvent: ".concat(JSON.stringify(event)));
    };
    /**
     * Send an event to the iframe.
     * @param {Object} message Data to send.
     */
    this.sendEvent = function (message) {
      if (_this._dispatcher != null) {
        _this._dispatcher(message);
      }
    };
    this.syncCoinsBalance = function (balance) {
      var _getFeatureConfig;
      var _useFeatureFlags = useFeatureFlags(),
        getFeatureConfig = _useFeatureFlags.getFeatureConfig;
      var syncCoins = (_getFeatureConfig = getFeatureConfig(FLAG_DEFAULT_VALUES.fe_provider_sync_coins)) === null || _getFeatureConfig === void 0 ? void 0 : _getFeatureConfig.enabled;
      syncCoins && store.dispatch(setCoin(balance));
    };
    /** Callback that child classes can use post dispatcher attachment */
    this.dispatcherAttached = function () {};
    this.getBetInfo = function () {};
    /**
     * Add XP to the local store.
     * If we've gained enough for a level, also trigger that.
     * @param {Number} amount The amount of XP to add.
     */
    this.AddLocalXP = function (amount) {
      var state = store.getState();
      var currentXp = state.xpInfo.xp;
      var xpRequired = state.xpInfo.xpRequired;
      console.log("Adding ".concat(amount, " XP. New XP: ").concat(currentXp + amount, "/").concat(xpRequired));
      store.dispatch(addXp(amount));

      // If this was enough xp to level up
      if (currentXp + amount >= xpRequired) {
        // Request server to try level up
        try {
          store.dispatch(getLevelUpData.initiate({}, {
            forceRefetch: true
          })).unwrap();
          setTimeout(function () {
            store.dispatch(getBattlesAndMissions.initiate({
              requestAssetsData: false
            }, {
              subscribe: false,
              forceRefetch: true
            }));
          }, 1000);
        } catch (error) {
          Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
            error: JSON.stringify(error),
            code: ERROR_CODE.LEVEL_UP_ERROR
          });
        }
      }
    };
    /**
     * Add XP to the local store based on bet amount.
     * Convenience method for AddLocalXP.
     */
    this.AddSpinXP = function (bet) {
      var state = store.getState();
      var coinAmount = parseInt(state.coin.value);
      if (coinAmount >= parseInt(bet)) {
        _this.AddLocalXP(_this.GetSpinXP(bet));
      }
    };
    /**
     * Helper method to return how much XP will be awarded for a spin
     * with given bet amount.
     * This amount is equal to the base XP per spin, plus the bet * multiplier;
     * @param {Number} bet How much the player is betting.
     */
    this.GetSpinXP = function (bet) {
      var state = store.getState();
      var baseSpinXp = state.xpInfo.xpPerSpin;
      var multiplier = state.xpInfo.xpBetMultiplier;
      var wagerBetMultiplier = 1;
      // if (betData.bonusXP && _lastPlayerBet >= betData.bonusXPThreshold) {
      //   wagerBetMultiplier = parseFloat(betData.bonusXP.multiplier)
      // }
      return (baseSpinXp + multiplier * bet) * wagerBetMultiplier;
    };
    this.CreditCoins = function (amount) {
      store.dispatch(addCoins(amount));
    };
    this.DebitCoins = function (amount) {
      var coinBalance = store.getState().coin.value;
      if (parseInt(coinBalance) >= parseInt(amount)) {
        store.dispatch(subtractCoins(amount));
      }
    };
    this.showOutOfCoinsScreen = function () {
      QueryParamsProxy.setQueryParams(_defineProperty({}, RouteParamConstants.PARAM_MODAL, Screens.OutOfCoin));
      var outOfCoins = store.getState().consumables.outOfCoins;
      var eventPayload = {
        product_id: outOfCoins === null || outOfCoins === void 0 ? void 0 : outOfCoins.CURRENCY_ITEM_ID,
        amount: outOfCoins === null || outOfCoins === void 0 ? void 0 : outOfCoins.PRICE
      };
      Logger.sendEvent(EVENT_TYPES.OOC_POP_UP_SHOWED, eventPayload);
    };
    this.GetLastWin = function () {
      return store.getState().lastWin.value;
    };
    this.SetLastWin = function (amount) {
      store.dispatch(setLastWin(amount));
    };
    this.showRateUsScreen = function () {
      var lastTimeRatePopup = store.getState().playerInfo.lastTimeRated;
      var newTime = new Date();
      var timeLimit = 86400000; // 24 * 60 * 60 * 1000 = 24 hours in ms;
      var timeDiff = !lastTimeRatePopup ? 0 : newTime - new Date(lastTimeRatePopup);
      if (timeDiff > timeLimit || timeDiff === 0) {
        ShowRateUs();
        store.dispatch(setLastTimeRatingSeen(newTime));
      }
    };
    this.showFtuePopUpAnimation = function () {
      var _useFeatureFlags2 = useFeatureFlags(),
        getFeatureConfig = _useFeatureFlags2.getFeatureConfig;
      var navigationBarLayout = getFeatureConfig(FE_LAYOUT)[LAYOUT.NAVIGATION_BAR];
      var isInverted = navigationBarLayout === NAVIGATION_BAR_LAYOUT.INVERTED;
      var style = null;
      if (generalUtils.isWebOrMobileWeb()) {
        var currentStopElm = document.getElementsByClassName('LevelBar');
        if (currentStopElm) {
          currentStopElm = currentStopElm[0];
          style = currentStopElm.getBoundingClientRect();
        }
      }
      var _tooltipDetails = generalUtils.isWebOrMobileWeb() ? {
        title: getText(TEXT_KEY.FTUE_LEVEL_UP_TO_GET),
        animationState: 'AnimationSlideFromTop',
        style: {
          display: 'flex',
          top: '12vh',
          left: style ? style.x + 40 : '15%',
          height: 160,
          zIndex: 400
        },
        showDivider: true,
        popUpType: TooltipTypes.FTUE
      } : {
        title: getText(TEXT_KEY.FTUE_LEVEL_UP_TO_GET),
        source: {},
        ibw: {},
        iconType: null,
        animationState: 'in',
        containerStyle: {
          width: _this._RFValue(215),
          height: _this._deviceInfo.isTablet() ? _this._RFValue(82) : _this._RFValue(100),
          top: _this._deviceInfo.isTablet() ? '10%' : '17%',
          left: _this._deviceInfo.isTablet() ? isInverted ? '63%' : '6%' : isInverted ? '63%' : '10%'
        },
        children: null,
        showDivider: true,
        popUpType: TooltipTypes.FTUE
      };
      store.dispatch(tooltipDetails(_tooltipDetails));
      store.dispatch(shouldShowTooltip(true));
      setTimeout(function () {
        _tooltipDetails.animationState = generalUtils.isWebOrMobileWeb() ? 'AnimationSlideToTop' : 'out';
        store.dispatch(tooltipDetails(_tooltipDetails));
        setTimeout(function () {
          store.dispatch(shouldShowTooltip(false));
        }, 800);
      }, 5000);
    };
    this.checkFtueStep = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var ftueStep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var message = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      if (!state) {
        store.dispatch(clearOnboarding());
        _this.showFtuePopUpAnimation();
        return;
      }
      store.dispatch(setOnboardingFtueStep(ftueStep));
      if (position) store.dispatch(setOnboardingHighlightedPosition(position, message));
    };
    this._deviceInfo = args.deviceInfo;
    this._RFValue = args.RFValue;
    this._dimension = args.dimension;
    this._exitFunc = args.ExitFunc;
    this._betInfo = args.BetInfo;
    this._defaultBet = args.BetInfo ? Number(((_args$BetInfo = args.BetInfo) === null || _args$BetInfo === void 0 ? void 0 : _args$BetInfo.defaultBet) || 0) * Number(((_args$BetInfo2 = args.BetInfo) === null || _args$BetInfo2 === void 0 ? void 0 : _args$BetInfo2.lines) || 1) : 0;
    this._betInfoSent = false;
    this._gameReady = args.GameReady;
    this._outOfCoins = args.OutOfCoins;
    this.showSpinEffect = false;
    this.timer = null;
    this.gameType = args.gameType;
    this.embedData = args.embedData;
    var storeState = store.getState();
    this.soundSettings = {
      soundEffects: storeState.playerInfo.soundEffects,
      music: storeState.playerInfo.music
    };
  }
  return _createClass(GameInterface, [{
    key: "receivedEvent",
    value:
    /**
     * @virtual
     * @param {import("./helpers/parseEvent").ParsedEvent} event
     */
    function receivedEvent(event) {
      switch (event._from) {
        case jsonParserName:
          {
            this.jsonParserEvent(event.payload);
            break;
          }
        case kvpParserName:
          {
            this.kvpParserEvent(event);
            break;
          }
        default:
          break;
      }
    }
  }, {
    key: "sendKeyValuePair",
    value:
    /**
     * Convenience method to send a kvp via sendEvent
     * @param {String} key
     * @param {String} value
     */
    function sendKeyValuePair(key) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var msg = "".concat(key.toString().toUpperCase(), ":").concat(value !== null ? value.toString().toUpperCase() : '');
      this.sendEvent(msg);
    }
  }, {
    key: "dispatcher",
    get: function get() {
      return this._dispatcher;
    },
    set:
    /**
     * Set this dispatcher that will post the message back to the game.
     * If already set, this is a no-op.
     */
    function set(value) {
      if (this._dispatcher === null) {
        this._dispatcher = value;
        this.dispatcherAttached();
      }
    }
  }, {
    key: "exitFunc",
    get: function get() {
      return this._exitFunc;
    }

    /**
     * @virtual
     * Define which parsers the wrapper should use.
     */
  }, {
    key: "parsers",
    get: function get() {
      return [jsonParser, kvpParser];
    }

    /**
     * @virtual
     * Which quest actions can this game interface support?
     * Used for determining best quest to show on tracker.
     */
  }, {
    key: "trackableActions",
    get: function get() {
      return [];
    }
  }]);
}();
export default GameInterface;